<template>
  <div style="margin-top: 15px">
    <basic-form
      :formProps="formProps"
      :success="isSuccess"
      :loading="isLoading"
      :pvm="pageValidationMessage"
      @submit="onSubmit"
    >
      <div class="pl-form-row">
        <input-group
          id="name"
          label="Full Name"
          type="text"
          :required="true"
          @input="onFieldInput($event)"
          @focus="onFieldFocus($event)"
          :validator="$v.form.name.$error"
        ></input-group>
        <select-group
          id="practice"
          label="GP Practice"
          :required="true"
          :options="[
            { name: 'GP Practice1', value: 'GP Practice1' },
            { name: 'GP Practice2', value: 'GP Practice2' },
          ]"
          @change="onChange($event)"
          @focus="onFieldFocus($event)"
          :validator="$v.form.practice.$error"
        ></select-group>
         <input-group
          id="phone"
          label="Phone Number"
          :required="true"
          @input="onFieldInput($event)"
          @focus="onFieldFocus($event)"
          :phoneValidator="$v.form.phone.$error"
        ></input-group>
        <input-group
          id="email"
          label="Email Address"
          type="email"
          :required="true"
          @input="onFieldInput($event)"
          @focus="onFieldFocus($event)"
          :emailValidator="$v.form.email.$error"
        ></input-group>
      </div>
      <div class="pl-form-row">
        <input-group
          id="query"
          groupClass="pl-form-row-item__full-width"
          label="Your Query"
          :textareaInput="true"
          :textareaRows="3"
          :required="true"
          @input="onFieldInput($event)"
          @focus="onFieldFocus($event)"
          :validator="$v.form.query.$error"
        ></input-group>
      </div>
      <p class="base-form-text">
        We will respond to your request within two working days.
      </p>
    </basic-form>
  </div>
</template>
<script>
import { formMixin, phoneCheck } from '@/mixins/formMixin'
import { required, email } from 'vuelidate/lib/validators'
import BasicForm from './BasicForm';
import InputGroup from './InputGroup';
import SelectGroup from './SelectGroup';

export default {
  name: 'QueryForm',
  components: {
    BasicForm,
    InputGroup,
    SelectGroup
  },
  mixins: [formMixin],
  props: {
    formProps: {
      title: String,
      text: Array,
      thank: String,
    },
    submitUrl: String
  },
  data() {
    return {
      form: {
        page: 'query',
        name: '',
        practice: '',
        phone: '',
        email: '',
        query: ''
      }
    };
  },
  validations: {
    form: {
      name: { required },
      practice: { required },
      phone: { required, phoneCheck },
      email: { required, email },
      query: { required }
    }
  }
};
</script>
